import { PAPERWORK_COMMON_ACTION_TYPES } from '../actions/common';
import { consts as insuranceEligibilityManualActivationConsts } from '../../profiles/insurance-eligibility-manual-activations';
import { consts as checkInsuranceEligibilityConsts } from '../../appointmentForm/requests/check-insurance-eligibility';

/**
 * @typedef {Object} QuestionAnswer
 * @property {string|boolean} answer
 * @property {string} question
 * @property {QuestionAnswer[]|undefined} childAnswers
 * */

/**
 * @typedef {Object} AdditionalInfoFormData
 * @property {QuestionAnswer} questionAnswers
 * */

/**
 * @typedef {Object} PaperworkCommonState
 * @property {boolean} pending
 * @property {Object} pages
 * @property {string[]} pages.formSteps
 * @property {Object[]} pages.allPages
 * @property {Object} data
 * @property {Object|null} data.pcpFormData
 * @property {number|null} data.insuranceEligibilityResultId
 * @property {boolean} data.isPlanNotListedSelected
 * @property {Object|null} data.additionalInfoFormData
 * */
const initialState = {
  pending: false,
  validating: true,
  pages: {
    formSteps: [],
    allPages: [],
  },
  data: {
    pcpFormData: null,
    insuranceEligibilityResultId: null,
    isPlanNotListedSelected: false,
    additionalInfoFormData: null,
  },
  isCameFromSubmitPage: false, // used to show success confirmation on the complete paperwork page
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_ADDITIONAL_INFO_FORM_DATA: {
      return {
        ...state,
        data: {
          ...state.data,
          additionalInfoFormData: payload,
        },
      };
    }

    case PAPERWORK_COMMON_ACTION_TYPES.GLOBAL_PAPERWORK_PENDING: {
      return {
        ...state,
        pending: payload,
      };
    }

    case PAPERWORK_COMMON_ACTION_TYPES.PAPERWORK_PAGE_INFO: {
      return {
        ...state,
        pages: {
          ...state.pages,
          ...payload,
        },
      };
    }

    case PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_PCP_FORM_DATA: {
      return {
        ...state,
        data: {
          ...state.data,
          pcpFormData: payload,
        },
      };
    }

    case insuranceEligibilityManualActivationConsts.SUCCEED:
    case checkInsuranceEligibilityConsts.SUCCEED: {
      return {
        ...state,
        data: {
          ...state.data,
          insuranceEligibilityResultId: payload.id,
        },
      };
    }
    case PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_INSURANCE_IS_PLAN_NOT_LISTED_SELECTED: {
      return {
        ...state,
        data: {
          ...state.data,
          isPlanNotListedSelected: payload,
        },
      };
    }

    case PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_CAME_FROM_SUBMIT_PAGE: {
      return {
        ...state,
        isCameFromSubmitPage: payload,
      };
    }

    case PAPERWORK_COMMON_ACTION_TYPES.GLOBAL_PAPERWORK_VALIDATING: {
      return {
        ...state,
        validating: payload,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/paperwork/reducers/common.js